import ApiService from './ApiService';

const ChatService = {
  conversations: () => ApiService.get('/conversations'),
  conversation: (id) => ApiService.get(`/conversations/${id}`),
  messages: (id, { before, limit = 50 } = {}) => ApiService.get(`/conversations/${id}/messages`, { before, limit }),
  send: (id, text) => ApiService.post(`/conversations/${id}/messages`, { text }),
  markRead: (id) => ApiService.post(`/conversations/${id}/read`),
  stop: (runId) => ApiService.post(`/runs/${runId}/stop`),
  status: () => ApiService.get('/workspace/status'),
  run: (runId) => ApiService.get(`/runs/${runId}`),
};

export default ChatService;
